//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Link, Tooltip } from '@mui/material';

type PathLinkProps = {
  stage: string;
  index: number;
  onClick: (index: number) => void;
  fullWidth?: boolean;
};

const PathLink = ({ stage, index, onClick, fullWidth }: PathLinkProps) => {
  const shortName = stage.substring(0, 19);
  const fullName = shortName !== stage ? stage : '';

  if (fullWidth) {
    return (
      <Link color="primary" onClick={() => onClick(index)}>
        {stage}
      </Link>
    );
  }

  return (
    <Tooltip title={fullName} key={stage}>
      <Link color="primary" onClick={() => onClick(index)}>
        {shortName}
        {fullName ? '...' : ''}
      </Link>
    </Tooltip>
  );
};
export default PathLink;
